import ServiceHighlights from "reusables/sections/ServiceHighlights";

const items = [
  {
    icon: "search",
    title: "Property Assessment",
    description:
      "We carry out a thorough assessment of your property's condition and identify any works required before tenants move in.",
  },
  {
    icon: "gavel",
    title: "Compliance Review",
    description:
      "We review your property against current regulatory requirements and advise on any certifications or remedial works needed.",
  },
  {
    icon: "assignment_turned_in",
    title: "Management Setup",
    description:
      "We establish the management framework — documentation, processes, and contacts — so everything is in place before we take over.",
  },
  {
    icon: "handshake",
    title: "Smooth Handover",
    description:
      "We coordinate a structured handover so the transition to managed letting is seamless for both landlord and tenants.",
  },
];

function Onboarding_Section1() {
  return (
    <ServiceHighlights title="Why Choose Our Property Assessment & Onboarding?" items={items} />
  );
}

export default Onboarding_Section1;
